import React from "react";
import * as Containers from "../components/containers";
import { http_fetch } from "../functions/http";
import axios, { post } from "axios";
export default class Compromisos extends React.Component {
  state = {
    compromisos: [],
    original: [],
    filtered: [],
    estado: "*",
    show: 266,
    stats: false,
    max: 266
  };
  componentDidMount() {
    this.getFirstData();
  }
  async getFirstData() {
    var r = await http_fetch("getCompromisos");
    if (r.data) {
      var d = r.data;
      this.setState({
        compromisos: d,
        original: d,
        filtered: d,
        max: d.length
      });
      this.filterCompromisos();
    }
  }
  getStats() {
    var stats = { status_5: 0, status_4: 0, status_3: 0, status_2: 0 };
    for (var i = 0; i < this.state.filtered.length; i++) {
      var em = this.state.filtered[i];
      var emcode = em.statusCode;
      stats["status_" + emcode] = stats["status_" + emcode] + 1;
    }
    this.setState({
      stats: stats
    });
  }
  trimCompromisos() {
    var s = this.state.show;
    var d = this.state.filtered;
    this.setState({
      compromisos: d
    });
    this.getStats();
  }
  filterString(s) {
    var r = s.toLowerCase();
    r = r.replace("á", "a");
    r = r.replace("é", "e");
    r = r.replace("í", "i");
    r = r.replace("ó", "o");
    r = r.replace("ú", "u");

    return r;
  }
  dictionary(s) {
    switch (s) {
      case "distrito federal":
        var o = "Ciudad de México";
        break;
      case "cdmx":
        var o = "Ciudad de México";
        break;
      case "edomex":
        var o = "Estado de México";
        break;
      case "bc":
        var o = "Baja California";
        break;
      case "bcs":
        var o = "Baja California Sur";
        break;
      default:
        var o = s;
        break;
    }
    if (o !== s) {
      var r = { v: this.filterString(o), changed: true };
      r.changedString = 'Se cambió "' + s + '" por "' + o + '"';
    } else {
      var r = { v: o, changed: false };
    }
    return r;
  }
  setEstado(estado) {
    this.setState({ estado: estado });
    var v = document.getElementById("searchInput").value;
    var self = this;
    setTimeout(function() {
      self.filterCompromisos(v);
    }, 200);
  }
  filterEstado(original) {
    var o = [];
    for (var i = 0; i < original.length; i++) {
      if (original[i].state == this.state.estado || this.state.estado == "*") {
        o.push(original[i]);
      }
    }
    return o;
  }
  filterCompromisos(by) {
    if (this.state.wait) {
      return;
    }
    var self = this;
    var d = this.state.original;
    var filtered = this.filterEstado(d);
    var show = 21;
    if (by) {
      var ft = [];
      var x = d.length;
      var srch = this.filterString(by);
      var dict = this.dictionary(srch);
      var add = "";
      if (dict.changed) {
        srch = dict.v;
        add += " (" + dict.changedString + ")";
      }
      for (var i = 0; i < x; i++) {
        var e = d[i];
        var included = false;
        var kys = ["name", "dep", "status"];
        for (var y = 0; y < kys.length; y++) {
          var tos = e[kys[y]];

          /* Filtra estado */
          var estado = this.state.estado;
          var isvalidstate = false;
          if (estado !== "*") {
            if (estado === e.state) {
              isvalidstate = true;
            }
          } else {
            isvalidstate = true;
          }

          tos = this.filterString(tos);
          if (tos.indexOf(srch) > -1 && !included && isvalidstate) {
            ft.push(e);
            included = true;
          }
        }
      }
      filtered = ft;
      show = ft.length;
    }
    this.setState({
      isfiltered: by ? true : false,
      filtered: filtered,
      add: add,
      show: show
    });
    setTimeout(function() {
      self.trimCompromisos();
    }, 200);
  }
  loadMore() {
    this.setState({
      show: this.state.compromisos.length + 21
    });
    var self = this;
    setTimeout(function() {
      self.trimCompromisos();
    }, 200);
  }
  tableView(bool) {
    document.body.classList.toggle("tableview", bool);
  }
  render() {
    var searchLabel = this.state.filtered.length + " compromisos";
    if (!this.state.filtered.length) {
      searchLabel = "No hay compromisos con este criterio de búsqueda.";
    }
    if (this.state.filtered.length === 1) {
      searchLabel = "Un compromiso";
    }

    var canload = this.state.compromisos.length + 21 <= this.state.max;
    canload =
      canload &&
      this.state.compromisos.length + 21 <= this.state.filtered.length;
    return (
      <Containers.Section id="compromisos">
        <div className="binder">
          <div className="titles">
            <h1>Los Compromisos</h1>
            <p>
              Estos son los 266 compromisos que Enrique Peña Nieto firmó en 2012
              como candidato a la Presidencia.
              <br />
              <span className="small">
                Fuente: Presidencia de la República. (Corte Julio 2018)
              </span>
              <br />
              <br />
              ¿Tienes información de estas promesas del presidente?<br />Da clic
              en <strong>Reportar</strong> y mándanos datos.
            </p>
          </div>
          <div className="tools">
            <div className="tool" id="filter_by_search">
              <select onChange={e => this.setEstado(e.target.value)}>
                <option value="*">Estados</option>
                <option value="Aguascalientes">Aguascalientes</option>
                <option value="Baja California">Baja California</option>
                <option value="Baja California Sur">Baja California Sur</option>
                <option value="Campeche">Campeche</option>
                <option value="Coahuila">Coahuila</option>
                <option value="Colima">Colima</option>
                <option value="Chiapas">Chiapas</option>
                <option value="Chihuahua">Chihuahua</option>
                <option value="Ciudad de México">Ciudad de México</option>
                <option value="Durango">Durango</option>
                <option value="Estado de México">Estado de México</option>
                <option value="Guanajuato">Guanajuato</option>
                <option value="Guerrero">Guerrero</option>
                <option value="Hidalgo">Hidalgo</option>
                <option value="Jalisco">Jalisco</option>
                <option value="Michoacán">Michoacán</option>
                <option value="Morelos">Morelos</option>
                <option value="Nayarit">Nayarit</option>
                <option value="Nuevo León">Nuevo León</option>
                <option value="Oaxaca">Oaxaca</option>
                <option value="Puebla">Puebla</option>
                <option value="Querétaro">Querétaro</option>
                <option value="Quintana Roo">Quintana Roo</option>
                <option value="San Luis Potosí">San Luis Potosí</option>
                <option value="Sinaloa">Sinaloa</option>
                <option value="Sonora">Sonora</option>
                <option value="Tabasco">Tabasco</option>
                <option value="Tamaulipas">Tamaulipas</option>
                <option value="Tlaxcala">Tlaxcala</option>
                <option value="Veracruz">Veracruz</option>
                <option value="Yucatán">Yucatán</option>
                <option value="Zacatecas">Zacatecas</option>
              </select>
            </div>
            <div className="tool" id="filter_by_search">
              <input
                type="text"
                id="searchInput"
                placeholder="Busca por palabras clave..."
                onChange={e => this.filterCompromisos(e.target.value)}
              />
              {this.state.isfiltered ? (
                <div className="search-label">
                  {searchLabel + this.state.add}
                </div>
              ) : null}
            </div>
          </div>

          {this.state.filtered.length > 0 && this.state.stats ? (
            <div className="stats">
              <div className="stat">
                <div className="cipher status_2">
                  {Math.ceil(
                    this.state.stats.status_2 / this.state.filtered.length * 100
                  )}
                  {"%"}
                </div>
                <div className="cipher_data">
                  Cumplidos ({this.state.stats.status_2})
                </div>
              </div>
              <div className="stat">
                <div className="cipher status_3">
                  {Math.ceil(
                    this.state.stats.status_3 / this.state.filtered.length * 100
                  )}
                  {"%"}
                </div>
                <div className="cipher_data">
                  En Proceso ({this.state.stats.status_3})
                </div>
              </div>
              <div className="stat">
                <div className="cipher  status_4">
                  {Math.ceil(
                    this.state.stats.status_4 / this.state.filtered.length * 100
                  )}
                  {"%"}
                </div>
                <div className="cipher_data">
                  Cancelados ({this.state.stats.status_4})
                </div>
              </div>
              <div className="stat">
                <div className="cipher status_5">
                  {Math.ceil(
                    this.state.stats.status_5 / this.state.filtered.length * 100
                  )}
                  {"%"}
                </div>
                <div className="cipher_data">
                  Suspendidos ({this.state.stats.status_5})
                </div>
              </div>
            </div>
          ) : null}

          <div className="compromisos_container">
            {this.state.compromisos.map(function(d) {
              return <Compromiso data={d} />;
            })}

            {canload ? (
              <div className="loadmore" onClick={() => this.loadMore()}>
                Ver más
              </div>
            ) : null}
          </div>
        </div>
        <input type="hidden" id="current-compromiso" value="" />
      </Containers.Section>
    );
  }
}
class Compromiso extends React.Component {
  showReport(c) {
    var t =
      'Quiero reportar el compromiso: "#' + c.compromiso + " " + c.name + '"';
    document.getElementById("report-lightbox-title").innerHTML = t;
    document.getElementById("current-compromiso").value =
      "#" + c.compromiso + " " + c.name;
    document.body.classList.add("showreport");
  }
  render() {
    var d = this.props.data;
    return (
      <div className="compromiso" id={"compromiso_" + d.compromiso}>
        <div className="n_circle">{"#" + d.compromiso}</div>
        <div className="compromiso_data">
          <div className="c_data estado">{d.state}</div>
          <div className="c_data dep">Dependencia: {d.dep}</div>
        </div>
        <div className="compromiso_name">{d.name}</div>
        <div className="compromiso_data bigdata">
          <div className={"c_data status status_" + d.statusCode}>
            {d.status}
          </div>
        </div>
        <div className="compromiso_report" onClick={() => this.showReport(d)}>
          Reportar
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout/compromisos.js